import { ModalStyles } from "./ItpManagerModal";
import { useGrid } from "@/state/grid";

/** Import from CAD/DWG — project topology ingest. */
export default function CadImportModal({ onClose }: { onClose: () => void }) {
  const setView = useGrid((s) => s.setView);
  return (
    <div className="gp-modal-overlay" onClick={onClose}>
      <div className="gp-modal" onClick={(ev) => ev.stopPropagation()} style={{ width: "min(640px,96vw)" }}>
        <div className="gp-modal-head">
          <h2>Import project topology from CAD/DWG</h2>
          <button className="gp-modal-x" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="gp-modal-body" style={{ fontSize: 13, lineHeight: 1.6, color: "var(--dim)" }}>
          <p>
            Upload engineering drawings (DWG / DXF) and the platform extracts the project structure automatically — fields,
            rows, tables, piles, stations, inverters, roads and fence.
          </p>
          <div
            style={{
              margin: "14px 0",
              padding: "12px 14px",
              borderRadius: 8,
              background: "rgba(44,155,115,.1)",
              border: "1px solid var(--grass)",
              color: "var(--ink)",
            }}
          >
            <b style={{ color: "var(--grass)" }}>✓ Topology imported</b>
            <div style={{ marginTop: 6, color: "var(--dim)" }}>
              13 fields · 1,125 PV tables · 304 inverters extracted from the Ballyroe field DXFs (ITM → WGS84) and the road &
              panel layout. View it on the geographic{" "}
              <a
                href="#"
                style={{ color: "var(--steel)", fontWeight: 600 }}
                onClick={(ev) => {
                  ev.preventDefault();
                  setView("sitemap");
                  onClose();
                }}
              >
                Site Map →
              </a>
            </div>
          </div>
          <p style={{ fontSize: 12 }}>
            To ingest a new revision, drop the updated CAD set with roads/fence on their own layers (corridors exploded to
            polylines). The extractor lives in <code style={{ color: "var(--hiviz)", fontFamily: "'IBM Plex Mono',monospace" }}>tools/dxf/</code>.
          </p>
        </div>
      </div>
      <ModalStyles />
    </div>
  );
}
